import React from "react";
import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet-async";
import RelatedArticles from "../../Components/RelatedArticles";

const DigitalImplant = () => {
  const { t, i18n } = useTranslation();
  const lang = i18n.language;

  const sections = t("digitalImplant.page.sections", { returnObjects: true });

  const faq = t("digitalImplant.faq", { returnObjects: true });

  return (
    <>
      <Helmet>
        <link
          rel="canonical"
          href="https://saleemsmile.com/articles/guided-implant-surgery"
        />

        <title>{t("digitalImplant.seo.title")}</title>
        <meta
          name="description"
          content={t("digitalImplant.seo.description")}
        />
        <meta name="keywords" content={t("digitalImplant.seo.keywords")} />
        <meta property="og:title" content={t("digitalImplant.seo.ogTitle")} />
        <meta
          property="og:description"
          content={t("digitalImplant.seo.ogDescription")}
        />
        <meta
          property="og:image"
          content="https://via.placeholder.com/800x450.png?text=Digital+Implant+Surgery"
        />
        <meta property="og:type" content="article" />
        <meta
          property="og:locale"
          content={lang === "ar" ? "ar_AR" : "en_US"}
        />

        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "FAQPage",
            mainEntity: faq.map((item) => ({
              "@type": "Question",
              name: item.question,
              acceptedAnswer: { "@type": "Answer", text: item.answer },
            })),
          })}
        </script>
      </Helmet>

      <article
        className="container my-5 pt-5"
        dir={lang === "ar" ? "rtl" : "ltr"}
      >
        <h1 className="fw-bold text-center mb-4" style={{ color: "#00b3ff" }}>
          {t("digitalImplant.page.title")}
        </h1>
        <h5 className="text-center mb-3">
          {t("digitalImplant.page.subtitle")}
        </h5>
        <p className="text-center text-muted mb-5">
          {t("digitalImplant.page.author")}
        </p>

        <section>
          <h2>{sections.introTitle}</h2>
          <p>{sections.introText}</p>
        </section>

        <section>
          <h2>{sections.mechanismTitle}</h2>
          <ol>
            {sections.mechanismList.map((item, idx) => (
              <li key={idx}>{item}</li>
            ))}
          </ol>
        </section>

        <section>
          <h2>{sections.comparisonTitle}</h2>
          <table className="table table-bordered text-center my-4">
            <thead className="table-light">
              <tr>
                {sections.comparisonTable.headers.map((header, idx) => (
                  <th key={idx}>{header}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {sections.comparisonTable.rows.map((row, idx) => (
                <tr key={idx}>
                  {row.map((cell, i) => (
                    <td key={i}>{cell}</td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </section>

        <section>
          <h2>{sections.benefitsTitle}</h2>
          <ul>
            {sections.benefitsList.map((item, idx) => (
              <li key={idx}>{item}</li>
            ))}
          </ul>
        </section>

        <section>
          <h2>{sections.conclusionTitle}</h2>
          <p>{sections.conclusionText}</p>
        </section>

        <RelatedArticles />
      </article>
    </>
  );
};

export default DigitalImplant;
